import React, { Component } from 'react'
import Radio from '@material-ui/core/Radio'
import { withStyles } from '@material-ui/core/styles'

class RadioButton extends Component {
  render() {
    const { onChange, checked, placeholder, classes, style } = this.props

    return (
      <div style={{ ...Styles.container, ...style }}>
        <Radio
          classes={{ checked: classes.checked }}
          checked={checked}
          onChange={() => onChange()}
        />
        <p>{placeholder}</p>
      </div>
    )
  }
}

const Styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  checked: {
    color: '#289e64 !important'
  }
}

export default withStyles(Styles)(RadioButton)



// WEBPACK FOOTER //
// ./src/components/common/RadioButton.js